import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from 'assets/locales/en.json';
import translationRU from 'assets/locales/ru.json';
import translationKK from 'assets/locales/kk.json';
import translationUZ from 'assets/locales/uz.json';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { Language } from '@generated/graphql';
import { LocaleKey } from 'types/i18n';

const languageMap: Record<string, Language> = {
  'ru-RU': Language.Ru,
  'en-US': Language.En,
  'en-GB': Language.En,
  'kk-KZ': Language.Kk,
  'uz-UZ': Language.Uz,
};

export const detectedLang = (lng: string) => languageMap[lng] || lng || 'ru';

const resources = {
  en: { translation: translationEN },
  ru: { translation: translationRU },
  kk: { translation: translationKK },
  uz: { translation: translationUZ },
};

const pluralizeMinutes = (
  count: number,
  lng: string | undefined,
): 'many' | 'one' | 'few' | 'other' => {
  const integerPart = Math.floor(count);

  if (lng === 'ru') {
    if (integerPart % 100 >= 11 && integerPart % 100 <= 14) return 'many';
    const lastDigit = integerPart % 10;
    if (lastDigit === 1) return 'one';
    if (lastDigit >= 2 && lastDigit <= 4) return 'few';
    return 'many';
  }

  return integerPart <= 1 ? 'one' : 'other';
};

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === 'minute') {
          const key = `time.minute_${pluralizeMinutes(value, lng)}` as LocaleKey;
          return i18n.t(key, { count: value });
        }
        return value;
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
